module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/user5-3c598286f96d98fd6bfe1c955b1f27d3.jpg";